import { IoReturnUpBackOutline } from "react-icons/io5";
import { FaRegTrashAlt } from "react-icons/fa";

import {
  ModalOverlay,
  ModalContainer,
  ModalContent,
  ModalTitle,
  ModalDescription,
  ModalSpanDescription,
  ModalButtonsContainer,
  ModalCancelButton,
  ModalConfirmButton,
} from "./styles";

export default function DeleteFlowModal({
  show,
  intl,
  initialData,
  name,
  deletingFlow,
  handleClose,
  handleConfirm,
  availableForInactivation = false,
}) {
  if (!show) return null;

  return (
    <ModalOverlay onClick={handleClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalContent>
          {!availableForInactivation ? (
            <>
              <ModalTitle>
                {intl.formatMessage(
                  { id: "CONFIRM_DELETE_FLOW" },
                  { flowName: initialData ? initialData?.name : name }
                )}
              </ModalTitle>

              <ModalDescription>
                {intl.formatMessage({
                  id: "CONFIRM_DELETE_FLOW_DESCRIPTION",
                })}
                <br />
                <ModalSpanDescription>
                  {intl.formatMessage({ id: "CONFIRM_DELETE_FLOW_ACTION" })}
                </ModalSpanDescription>
              </ModalDescription>
            </>
          ) : (
            <>
              <ModalTitle>
                {intl.formatMessage(
                  { id: "CONFIRM_INACTIVATION_FLOW_TITLE" },
                  { flowName: initialData ? initialData?.name : name }
                )}
              </ModalTitle>

              <ModalDescription>
                {intl.formatMessage({
                  id: "CONFIRM_INACTIVATION_FLOW_DESCRIPTION",
                })}
              </ModalDescription>
            </>
          )}

          <ModalButtonsContainer>
            <ModalCancelButton
              type="button"
              onClick={handleClose}
              disabled={deletingFlow}
            >
              <IoReturnUpBackOutline size={24} />
              <span>
                {intl.formatMessage({ id: "CONFIRM_DELETE_FLOW_BACK" })}
              </span>
            </ModalCancelButton>

            <ModalConfirmButton
              type="button"
              onClick={handleConfirm}
              disabled={deletingFlow}
            >
              <FaRegTrashAlt size={18} />
              {deletingFlow ? (
                <span>
                  {intl.formatMessage({
                    id: "CONFIRM_DELETE_FLOW_DELETING",
                  })}
                </span>
              ) : (
                <span>
                  {intl.formatMessage({ id: "CONFIRM_DELETE_FLOW_DELETE" })}
                </span>
              )}
            </ModalConfirmButton>
          </ModalButtonsContainer>
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
}
